// extracted by mini-css-extract-plugin
export default {"rights__container":"RightsPage_rights__container__NAK8k"};